import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var TimelineItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimelineItem, _React$PureComponent);

  var _super = _createSuper(TimelineItem);

  function TimelineItem() {
    _classCallCheck(this, TimelineItem);

    return _super.apply(this, arguments);
  }

  _createClass(TimelineItem, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          classPrefix = _a.classPrefix,
          last = _a.last,
          className = _a.className,
          dot = _a.dot,
          time = _a.time,
          rest = __rest(_a, ["children", "classPrefix", "last", "className", "dot", "time"]);

      var addPrefix = function addPrefix(clx) {
        return "".concat(classPrefix, "-").concat(clx);
      };

      var classes = classNames(classPrefix, className, _defineProperty({}, addPrefix('last'), last));
      return /*#__PURE__*/React.createElement("li", _Object$assign({
        className: classes
      }, rest), /*#__PURE__*/React.createElement("span", {
        className: addPrefix('tail')
      }), /*#__PURE__*/React.createElement("span", {
        className: classNames(addPrefix('dot'), _defineProperty({}, addPrefix('custom-dot'), !!dot))
      }, dot), time && /*#__PURE__*/React.createElement("div", {
        className: addPrefix('time')
      }, time), /*#__PURE__*/React.createElement("div", {
        className: addPrefix('content')
      }, children));
    }
  }]);

  return TimelineItem;
}(React.PureComponent);

TimelineItem.propTypes = {
  last: PropTypes.bool,
  dot: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  classPrefix: PropTypes.string
};
TimelineItem.defaultProps = {
  classPrefix: 'roo-timeline-item',
  last: false,
  dot: undefined,
  className: '',
  children: null
};
export default TimelineItem;